var React = require('react');

function StepElips (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M62.5672 29.2663C63.8378 42.7271 53.285 59.2828 39.832 60.5527C25.695 64.017 3.14712 56.7014 2.98217 36.1011C2.88379 23.815 20.8898 3.67302 34.3428 2.40308C47.7958 1.13313 61.2965 15.8055 62.5672 29.2663Z","fill":"#FFCA08","fillOpacity":"0.8"}));
}

StepElips.defaultProps = {"width":"66","height":"65","viewBox":"0 0 66 65","fill":"none"};

module.exports = StepElips;

StepElips.default = StepElips;
